import { Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import { tap } from 'rxjs';
import { GetFormaGiuridicaGQL } from '../../_graphql/generated';

export const getFormaGiuridica =
  (injector: Injector, store: any, getter: GetFormaGiuridicaGQL) => () =>
    runInInjectionContext(injector, () => {
      return getter
        .fetch(
          {},
          {
            context: { headers: { 'x-hasura-role': 'anonymous' } },
            fetchPolicy: 'cache-first',
          },
        )
        .pipe(
          tap(() => patchState(store, { loading: true })),
          tapResponse({
            next: (res) => {
              patchState(store, {
                loading: false,
                lista: res.data?.anagrafica_forma_giuridica,
                failure: undefined,
              });
            },
            error: (error) => {
              patchState(store, {
                loading: false,
                failure: error,
              });
            },
          }),
        );
    });
